type PaypalVaultCart = {
  vault_without_charge?: boolean;
};

export const shouldUsePaypalVaultFlow = (
  cart?: PaypalVaultCart | null,
  fundingSource?: string,
): boolean => cart?.vault_without_charge === true && fundingSource === "paypal";

type PaypalApprovalData = {
  orderID?: string | null;
  vaultSetupToken?: string | null;
};

export type PaypalAuthorizeRequest =
  | { kind: "charge"; cartToken: string; orderId: string }
  | { kind: "vault"; cartToken: string; setupTokenId: string };

// Map a PayPal approval payload plus the cart token to a discriminated
// authorize request the checkout handler dispatches to the matching endpoint:
// vault -> authorizePaypalVaultOrder, charge -> authorizePaypalOrder.
//
// Vault-first: the SDK's vault `onApprove` data does NOT carry the setup token
// (OnApproveData exposes only orderID/payerID/etc. in @paypal/paypal-js@9.4.0),
// so Cycle 4 captures the token from the createVaultSetupToken() return and
// passes it here as `vaultSetupToken`. We accept it as an optional field and
// prefer it over `orderID` when present.
export const buildPaypalAuthorizeRequest = (
  data: PaypalApprovalData,
  cartToken: string,
): PaypalAuthorizeRequest => {
  if (typeof data.vaultSetupToken === "string" && data.vaultSetupToken !== "") {
    return { kind: "vault", cartToken, setupTokenId: data.vaultSetupToken };
  }

  if (typeof data.orderID === "string" && data.orderID !== "") {
    return { kind: "charge", cartToken, orderId: data.orderID };
  }

  throw new Error(
    "Cannot build PayPal authorize request: approval data has neither a vaultSetupToken nor an orderID",
  );
};
